import script from "./NewHabitView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewHabitView.vue?vue&type=script&setup=true&lang=js"

import "./NewHabitView.vue?vue&type=style&index=0&id=7f587a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f587a4e"]])

export default __exports__